export default {
  header: 'Wybierz specyfikację do załadowania',
  hint: 'Nie wszystkie czujniki są przypisane do tego sprzętu',
};
